import { render, staticRenderFns } from "./PricesFormComponent.vue?vue&type=template&id=95a2e86a&xmlns=true&"
import script from "./PricesFormComponent.vue?vue&type=script&lang=js&"
export * from "./PricesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a2e86a')) {
      api.createRecord('95a2e86a', component.options)
    } else {
      api.reload('95a2e86a', component.options)
    }
    module.hot.accept("./PricesFormComponent.vue?vue&type=template&id=95a2e86a&xmlns=true&", function () {
      api.rerender('95a2e86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/basic-data/forms/prices-form/PricesFormComponent.vue"
export default component.exports